import React from "react";
import { Button } from "../../../../ui/components/Button";
import {
  getPostedStatusLabel,
  getStoredAccountingBackend,
} from "../../../../config/accounting";
import { DebitNoteListStatus } from "../../domain";

interface DebitNoteStatusFilterPillsProps {
  value: DebitNoteListStatus;
  onChange: (value: DebitNoteListStatus) => void;
}

export const DebitNoteStatusFilterPills: React.FC<
  DebitNoteStatusFilterPillsProps
> = ({ value, onChange }) => {
  const options: Array<{ value: DebitNoteListStatus; label: string }> = [
    { value: "all", label: "All" },
    { value: "pending", label: "Pending" },
    { value: "under_review", label: "Under Review" },
    {
      value: "posted",
      label: getPostedStatusLabel(getStoredAccountingBackend()),
    },
    { value: "rejected", label: "Rejected" },
  ];

  return (
    <div className="flex flex-wrap items-center gap-2">
      {options.map((option) => (
        <Button
          key={option.value}
          variant={value === option.value ? "brand-primary" : "neutral-secondary"}
          size="small"
          onClick={() => onChange(option.value)}
        >
          {option.label}
        </Button>
      ))}
    </div>
  );
};
